import React from "react";

import { collection, doc, getDocs, getFirestore, query, writeBatch } from "firebase/firestore";
import { getStorage } from "firebase/storage";

import app from "../firebase";
import { Dev } from "../util/consoleUtil";
import firebaseError from "../util/firebaseError";

import { CafeteriaType } from "../../types/database";

const db = getFirestore(app);
const storage = getStorage(app);

export const ExportService = {
  All: () => {
    const [isLoading, setLoading] = React.useState(false);

    const [items, setItems] = React.useState<CafeteriaType[]>([]);

    const runRequest = async (collectionId: string) => {
      return new Promise(async (Ok, Rej) => {
        try {
          setLoading(true);

          const mainRef = collection(db, collectionId);
          const queryRef = query(mainRef);
          const mainSnap = await getDocs(queryRef);
          const listData = [] as any;

          mainSnap.forEach((doc) => {
            listData.push({ id: doc.id, ...doc.data() });
          });

          setItems(listData);

          setLoading(false);
          Ok(listData);
        } catch (error) {
          console.log(...new Dev("Request Error [list]", error).Error());
          setLoading(false);
          Rej(new Error("Erro ao obter dados. " + firebaseError(error)));
        }
      });
    };

    return { items, isLoading, runRequest };
  },

  Move: () => {
    const [isLoading, setLoading] = React.useState(false);

    const runRequest = async (collectionId: string, items: any[]) => {
      return new Promise(async (Ok, Rej) => {
        try {
          setLoading(true);

          const batchRef = writeBatch(db);

          items.forEach((data) => {
            const filteredData = { ...data };
            delete filteredData.id;
            const docRef = doc(db, collectionId, data.id);
            batchRef.set(docRef, filteredData);
          });

          const batchRes = await batchRef.commit();

          setLoading(false);
          Ok(batchRes);
        } catch (error) {
          console.log(...new Dev("Request Error [create]", error).Error());
          setLoading(false);
          Rej(new Error("Erro ao criar dados. " + firebaseError(error)));
        }
      });
    };

    return { isLoading, runRequest };
  },
};
